import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { arProfileSubCountsSelector } from 'selectors/user/arProfileSubCountsSelector';
import { getFeatureFlags } from 'components/RichProfile/MyAccount/AutoReplenishment/utils/featureFlags';

/**
 * Custom hook for Auto Replenishment Page Content component.
 * Determines whether to render the empty hub or regular auto replenishment content
 * based on feature flags and user subscription status.
 *
 * @returns {Object} Hook state
 * @returns {boolean} returns.shouldRenderEmptyHub - True if empty hub should be displayed
 */
const useAutoReplenishmentPageContent = () => {
    const subscriptionCounts = useSelector(arProfileSubCountsSelector);

    const featureFlags = useMemo(getFeatureFlags, []);

    const hasAnySubscriptions = subscriptionCounts.active > 0 || subscriptionCounts.paused > 0 || subscriptionCounts.cancelled > 0;
    const shouldRenderEmptyHub = featureFlags.isAutoReplenishEmptyHubEnabled && !hasAnySubscriptions;

    return {
        shouldRenderEmptyHub
    };
};

export default useAutoReplenishmentPageContent;
